import React from 'react';
import { TouchableOpacityProps } from 'react-native';
import { GenericTouchableProps } from 'react-native-gesture-handler/lib/typescript/components/touchables/GenericTouchable';
import styled from 'styled-components/native';

import { Feather } from '@expo/vector-icons';

import Colors from '../constants/Colors';
import { Caption } from './Typography';

const SnackbarView = styled.TouchableOpacity<SnackbarProps>`
  position: absolute;
  bottom: 20px;
  flex-direction: row;
  border-radius: 8px;
  align-self: center;
  padding: 16px 16px 16px 8px;
  background-color: ${Colors.primaryPurple};
` as React.FC<SnackbarProps>;

const IconView = styled.View`
  margin-right: 8px;
`;

const AlertText = styled(Caption)`
  font-size: 16px;
  line-height: 20px;
  margin-top: 3px;
`;

export type SnackbarProps = TouchableOpacityProps &
  GenericTouchableProps & {
    disabled?: boolean;
  };

const Snackbar: React.FC<SnackbarProps> = ({ children, ...props }) => {
  return (
    <SnackbarView activeOpacity={0.7} {...props}>
      <IconView>
        <Feather name='check' size={24} color='white' />
      </IconView>
      <AlertText color='light'>{children}</AlertText>
    </SnackbarView>
  );
};

export default Snackbar;
